.root {
  position: relative;
  width: 268px;
  height: 91px;
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  padding: 12px;
  border-radius: var(--border-radius);
  background: white;
  border: 1px solid;
  border-color: var(--color-gray-70);
  box-shadow: none;
  cursor: pointer;
  overflow: hidden;

  &:not(.disabled):hover {
    border-color: var(--color-primary-light);
    box-shadow: 0 1px 27px rgba(31, 44, 75, 0.1);
  }

  &.selected {
    border-color: var(--color-primary-default);
  }

  &.disabled {
    cursor: auto;
  }
}
.disabled {
}
.selected {
}

.content {
  min-width: 0;
  display: flex;
  flex-flow: column nowrap;
  gap: 4px;
  padding-top: 4px;
}

.title {
  color: var(--color-gray-black);
  flex-shrink: 0;
}

.copy {
  color: var(--color-gray-30);
}

.icon {
  // The card is a flex row, so without this the image's own width is what the box is sized from.
  flex: 0 0 auto;
  width: 70px;
  height: 67px;

  // A saved template's image is SVG markup the template carries, drawn at whatever size its author
  // gave it — without this the card is painted over by a full-size one.
  > svg {
    width: 100%;
    height: 100%;
  }
}
